import { Box } from '@Backlot-Cars/archie';
import ProgressBar from 'components/ProgressBar';
import { useTranslation } from 'next-i18next';

const AuctionAccessProgress = ({ activeStep = 1 }) => {
	const { t } = useTranslation(['signup']);
	const steps = [
		t('signup:auctionAccessLookup.progress.informationReview'),
		t('signup:auctionAccessLookup.progress.documents'),
		t('signup:auctionAccessLookup.progress.paymentMethods'),
	];

	return (
		<Box width="100%">
			<ProgressBar selectedStep={activeStep} steps={steps} />
		</Box>
	);
};

export default AuctionAccessProgress;
